<div class="dd-contact">
  <div class="dd-contact__panel color-scheme-light">
    <div class="dd-contact__info">
      <div class="dd-contact__info-col">
        <p>
          Tel: <a [href]="phoneHref">{{ phone }}</a><br />
          E-Mail: <a [href]="'mailto:' + email">{{ email }}</a>
        </p>
      </div>
      <div class="dd-contact__info-col">
        <p>
          1970 NW 129 Ave, Suite 105<br />
          Miami, FL 33182
        </p>
      </div>
    </div>

    @if (sent()) {
      <p class="dd-contact__thanks">Thank you. Your message has been sent.</p>
    } @else {
      <form class="wpcf7-form dd-contact__form" (submit)="submit($event)" novalidate>
        <div class="row dd-contact__form-row">
          <div class="col-md-6">
            <p>
              <label>Your Name (required)</label>
              <input type="text" name="your-name" [(ngModel)]="name" required />
            </p>
            <p>
              <label>Your Email (required)</label>
              <input type="email" name="your-email" [(ngModel)]="emailValue" required />
            </p>
            <p>
              <label>Subject</label>
              <input type="text" name="your-subject" [(ngModel)]="subject" />
            </p>
          </div>
          <div class="col-md-6 dd-contact__message">
            <p>
              <label>Your Message</label>
              <textarea name="your-message" [(ngModel)]="message"></textarea>
            </p>
          </div>
        </div>
        @if (error()) {
          <p class="dd-contact__error">{{ error() }}</p>
        }
        <p>
          <input
            class="wpcf7-submit btn btn-color-white btn-style-bordered"
            type="submit"
            value="SEND A MESSAGE"
          />
        </p>
      </form>
    }

    <ul class="social-icons text-left icons-design-colored icons-size-small social-share">
      <li class="social-facebook">
        <a
          href="https://www.facebook.com/sharer/sharer.php?u=https://diffuserdreams.net/contact-us/"
          target="_blank"
          rel="noopener noreferrer nofollow"
          aria-label="Facebook"
        >
          <i class="icon-social-facebook"></i>
          <span class="basel-social-icon-name">Facebook</span>
        </a>
      </li>
    </ul>
  </div>

  <div class="dd-contact__map">
    <iframe
      [src]="mapSrc"
      title="1970 NW 129th Ave STE 105, Miami, FL 33182"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
      allowfullscreen
    ></iframe>
  </div>
</div>
